export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Měna"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vytvořit zprávu"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Výsledek měny"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Stáhnout"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["List"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Povolený formát souboru - xlsx"])}
}